import React from 'react';
import MediaQuery from 'react-responsive';
// import api from '../../../api-client';
import classnames from 'classnames';
import Button from '../../button/Button';
import { Row, Col } from 'react-flexbox-grid';
import styles from './Email.styl';

function validateEmail(emailAddress) {
  var re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(emailAddress);
}

function validate(fullName, emailAddress) {
  let emailValidate = validateEmail(emailAddress);

  return {
    fullName: fullName.length === 0,
    emailAddress: !emailValidate
  };
}

class Email extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optIn: true,
      fullName: '',
      emailAddress: '',
      emailSubject: 'Support the PAW and FIN Conservation Act (H.R. 4348/S. 2491)',
      emailBody:
        'The Endangered Species Act (ESA) is among our country’s most important tools for saving wildlife from extinction. Nearly every single species that has been listed under the ESA has survived, and many have recovered. Without the ESA, bald eagles, Florida manatees, American alligators, and a host of other iconic species would likely be gone forever.\n\nThat is why I urge you to support the Protect America’s Wildlife and Fish In Need of Conservation (PAW and FIN Conservation) Act, to reverse harmful regulations aimed at undermining the ESA which were finalized last year. If allowed to stand, these regulations would remove longstanding automatic protections for newly listed threatened species; reduce the requirement for agencies to consult with experts about species and habitats; and make economic issues a part of the process for protecting species. In short, these regulations remove critical protections for imperiled species, and could cause more extinctions.\n\nThe ESA is a highly effective, flexible, and popular law. Please safeguard the ESA - and the species it protects - by supporting the PAW and FIN Conservation Act.\n',
      touched: {
        fullName: false,
        emailAddress: false
      },
      errors: {
        fullName: false,
        emailAddress: false
      }
    };

    this.handleChangeFor = this.handleChangeFor.bind(this);
    this.handleBlurFor = this.handleBlurFor.bind(this);
  }

  handleBlurFor = propertyName => event => {
    this.setState({
      touched: {
        ...this.state.touched,
        [propertyName]: true
      }
    });
  };

  handleChangeFor = propertyName => event => {
    if(propertyName == 'optIn') {
      this.setState({ optIn: event.target.checked });
    } else {
      this.setState({ [propertyName]: event.target.value });
    }
    console.log(propertyName, event.target.checked);
  };

  handleClick = () => {
    this.props.sendEmail(this.state);
  };

  render() {
    const errors = validate(this.state.fullName, this.state.emailAddress);
    const isDisabled =
      Object.keys(errors).some(x => errors[x]) ||
      this.props.emailSentLoading === true;
    const shouldMarkError = field => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];

      return hasError ? shouldShow : false;
    };

    return (
      <div className={styles.formOuterWrapper}>
        <div className={styles.formInnerWrapper}>
          <div>
            <Row>
              <Col xs={12} sm={6}>
                <input
                  type="text"
                  placeholder="FULL NAME - required"
                  value={this.state.fullName}
                  onChange={this.handleChangeFor('fullName')}
                  className={classnames(
                    styles.input,
                    shouldMarkError('fullName') ? [styles.error] : ''
                  )}
                  onBlur={this.handleBlurFor('fullName')}
                />
              </Col>
              <Col xs={12} sm={6}>
                <input
                  type="email"
                  placeholder="EMAIL ADDRESS - required"
                  value={this.state.emailAddress}
                  onChange={this.handleChangeFor('emailAddress')}
                  className={classnames(
                    styles.input,
                    shouldMarkError('emailAddress') ? [styles.error] : ''
                  )}
                  onBlur={this.handleBlurFor('emailAddress')}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="SUBJECT: PROTECT THE ENDANGERED SPECIES ACT"
                  value={this.state.emailSubject}
                  onChange={this.handleChangeFor('emailSubject')}
                />
              </Col>
            </Row>
          </div>

          <div className={styles.emailBox}>
            <span>* Personalize for greater impact</span>
            <div className={styles.textareaWrapper}>
              <textarea
                value={this.state.emailBody}
                onChange={this.handleChangeFor('emailBody')}
              />
            </div>
          </div>

          <MediaQuery minDeviceWidth={768}>
            <Row className={styles.buttonRow} center="xs">
              <Col xs={12} sm={12} md={12} className={styles.optInButton}>
                <div className={styles.checkbox}>
                  <input type="checkbox" id="opt-in-checkbox" defaultChecked={true} onChange={this.handleChangeFor('optIn')} />
                  <label htmlFor="opt-in-checkbox">Stay up to date on the animals and issues you care about most. You can unsubscribe at any time.</label>
                </div>
              </Col>
              <Col xs={12} sm={4} md={3} className={styles.leftButton}>
                <Button
                  title="Cancel"
                  color="#003973"
                  setContactType={this.props.setContactType}
                  type={null}
                  clearSelectedMembers={this.props.clearSelectedMembers}
                />
              </Col>
              <Col xs={12} sm={4} md={3} className={styles.rightButton}>
                <Button
                  title={
                    this.props.emailSentLoading ? 'SENDING...' : 'SEND EMAIL'
                  }
                  color={this.props.sendEmailInputError ? '#D64948' : '#003973'}
                  sendEmail={this.props.sendEmail}
                  emailInfo={this.state}
                  disabled={isDisabled}
                  showLoader={this.props.emailSentLoading}
                />
              </Col>
            </Row>
          </MediaQuery>
        </div>
        <MediaQuery maxDeviceWidth={767}>
          <div className={styles.mobileButton} onClick={this.handleClick}>
            {this.props.emailSentLoading ? 'SENDING...' : 'SEND EMAIL'}
          </div>
        </MediaQuery>
      </div>
    );
  }
}

export default Email;



// WEBPACK FOOTER //
// ./src/components/forms/email/Email.js